import { useEffect } from "react";
import Hero from "@/components/site/Hero";
import WorkGrid from "@/components/site/WorkGrid";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Clients from "@/components/site/Clients";
import Contact from "@/components/site/Contact";

export default function Home() {
    useEffect(() => {
        document.title = "MIDI Pictures — Create to share";
    }, []);
    return (
        <main data-testid="home-page" className="bg-black">
            <Hero />
            <WorkGrid limit={4} />
            <Services />
            <About />
            <Clients />
            <Contact />
        </main>
    );
}
